import { render } from "./RecruitmentBrand.vue?vue&type=template&id=088ffb60&scoped=true"
import script from "./RecruitmentBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitmentBrand.vue?vue&type=script&setup=true&lang=js"

import "./RecruitmentBrand.vue?vue&type=style&index=0&id=088ffb60&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088ffb60"],['__file',"src/views/recruitment/brand/RecruitmentBrand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "088ffb60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('088ffb60', __exports__)) {
    console.log('reload')
    api.reload('088ffb60', __exports__)
  }
  
  module.hot.accept("./RecruitmentBrand.vue?vue&type=template&id=088ffb60&scoped=true", () => {
    console.log('re-render')
    api.rerender('088ffb60', render)
  })

}


export default __exports__